export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'cat-culture',
    name: '猫咪文化',
    description: '探索猫咪在历史、艺术与文学中的优雅足迹，感受千年猫文化的深厚底蕴',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20cat%20in%20vintage%20library%20with%20antique%20books%2C%20warm%20golden%20light%2C%20classic%20study%20room%2C%20refined%20cultural%20atmosphere&width=600&height=450&seq=cat-culture-01&orientation=landscape',
  },
  {
    slug: 'gentleman-aesthetics',
    name: '绅士美学',
    description: '以绅士的品味审视生活，将猫咪的优雅与人类精致审美完美融合',
    icon: 'ri-vip-crown-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cat%20on%20velvet%20armchair%20in%20elegant%20living%20room%20with%20classic%20furniture%2C%20warm%20ambient%20lighting%2C%20sophisticated%20interior%20design&width=600&height=450&seq=gentleman-aesthetics-01&orientation=landscape',
  },
  {
    slug: 'curated-goods',
    name: '精选好物',
    description: '严选高品质猫咪用品与家居好物，为绅士猫咪打造格调生活空间',
    icon: 'ri-gift-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20cat%20products%20displayed%20on%20wooden%20shelf%2C%20ceramic%20bowls%2C%20natural%20toys%2C%20minimalist%20aesthetic%2C%20warm%20natural%20light&width=600&height=450&seq=curated-goods-01&orientation=landscape',
  },
  {
    slug: 'cat-care-guide',
    name: '养猫指南',
    description: '从饮食营养到健康护理，专业且优雅的养猫知识，做一位真正的喵绅士',
    icon: 'ri-heart-pulse-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Healthy%20cat%20being%20examined%20by%20veterinarian%20in%20bright%20modern%20clinic%2C%20professional%20care%2C%20clean%20white%20interior%2C%20warm%20atmosphere&width=600&height=450&seq=cat-care-guide-01&orientation=landscape',
  },
  {
    slug: 'elegant-living',
    name: '优雅生活',
    description: '将猫咪融入精致日常，品茶、阅读、旅行——与猫共度的诗意时光',
    icon: 'ri-cup-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cat%20lounging%20by%20window%20with%20tea%20cup%20and%20book%2C%20cozy%20afternoon%20sunlight%2C%20serene%20lifestyle%2C%20warm%20cream%20interior&width=600&height=450&seq=elegant-living-01&orientation=landscape',
  },
  {
    slug: 'cat-stories',
    name: '喵星故事',
    description: '来自世界各地的猫咪故事，温馨、治愈、充满灵性的猫咪传奇',
    icon: 'ri-chat-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cat%20looking%20out%20window%20at%20sunset%2C%20nostalgic%20warm%20light%2C%20storytelling%20atmosphere%2C%20emotional%20portrait%20of%20cat&width=600&height=450&seq=cat-stories-01&orientation=landscape',
  },
];